import { render, staticRenderFns } from "./InvoiceDeliveryMethodSelect.vue?vue&type=template&id=1b942a3e&"
import script from "./InvoiceDeliveryMethodSelect.vue?vue&type=script&lang=js&"
export * from "./InvoiceDeliveryMethodSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports